import { render, staticRenderFns } from "./gj-table-tab.vue?vue&type=template&id=e293bb62&"
import script from "./gj-table-tab.vue?vue&type=script&lang=js&"
export * from "./gj-table-tab.vue?vue&type=script&lang=js&"
import style0 from "./gj-table-tab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports